<template>
  <div
    class="flex items-center flex-col md:justify-between"
    :class="reverse ? 'md:flex-row-reverse' : 'md:flex-row'"
  >
    <div class="text-block flex-auto text-center md:text-left">
      <TypeDisplay variant="giga" weight="strong" tag="p" class="mb-2">{{
        title
      }}</TypeDisplay>
      <TypeHeading variant="headline" weight="regular" tag="p"
        ><span v-html="descriptionNLBR"></span
      ></TypeHeading>
    </div>

    <img
      :src="image"
      class="image w-full max-w-lg flex-shrink-1 md:flex-shrink-0 p-6"
    />
  </div>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { TypeHeading, TypeDisplay } from '@bambeehr/pollen';

export default defineComponent({
  name: 'InfoBlock',
  components: { TypeHeading, TypeDisplay },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const descriptionNLBR = computed(() =>
      props.description.replace('\n', '<br /> <br />')
    );
    return {
      descriptionNLBR,
    };
  },
});
</script>
